export class QueryStringService {

	getQueryString() {
		return window.location.search.substr(1);
	}

	/**
	 * Gets a value from key=value pair
	 *
	 * @param  string keyValueToLookFor Which key to return value from
	 * @return string || null
	 */
	getQueryStringValue(keyValueToLookFor) {
		let params = this.getQueryString().split("&");

		for (var i = 0; i < params.length; i++) {
			// params[i] = "key=value"
			let strings = params[i].split("=");
			let paramKey = strings[0];
			let paramValue = strings[1];

			// if key matches querykey return value
			if (paramKey == keyValueToLookFor) {
				return paramValue;
			}
		}
		return null;
	}
}
